<template>
  <div class="configure-location">
    <header-mobile-page label="Configure Location Screen" />
    <geofence-configure-screen :mode="mode"
                               :named-location-id="locationId"
                               :location-from-history="locationFromHistory" />
  </div>
</template>

<script>
  import GeofenceConfigureScreen from '@/components/Common/Geofence/GeofenceConfigureScreen'
  import HeaderMobilePage from '@/components/Header/HeaderMobilePage'

  export default {
    components: {
      GeofenceConfigureScreen,
      HeaderMobilePage
    },

    props: {
      mode: {
        type: String
      },

      locationId: {
        type: Number
      },

      locationFromHistory: {
        type: Object
      }
    }
  }
</script>

<style lang="scss" scoped>
  .configure-location {
    width: 100%;
    height: auto;

    padding: 0 0 10px 0;
  }
</style>